var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('board-list-widget',{attrs:{"org-ref":_vm.orgRef,"title":"leads","entity-type":"lead","board-link":"leadBoard","read-only":""}})}
var staticRenderFns = []

export { render, staticRenderFns }